import React, { useContext, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu'
import { StyledNav, StyledLink } from './Nav.styled';
import { MobileNavItems } from '../../../constants/NavItems';
import MobileMenuImage from '../../../assets/images/burger-bar.png'
import { PlayerContext } from '../../../contexts/playerContext';
import { StyledMobileMenuFooterWrapper } from '../Profile/Profile.styled';

const MobileNav = () => {
    const location = useLocation();
    const playerContext = useContext(PlayerContext);

    const handleConnectWallet = () => {
        playerContext?.handleConnectWallet();
    }

    const handleDisConnectWallet = async () => {
        await playerContext?.wallet.disconnect();
    }

    return (
        <StyledNav className='mobile'>
            <Menu customBurgerIcon={<img src={MobileMenuImage} />}>
                <div>
                    {
                        MobileNavItems.map((item, index) => (
                            <StyledLink to={item.link} key={index} className={`${location.pathname == item.link ? "active" : ""}`}>{item.title}</StyledLink>
                        ))
                    }
                </div>
                <StyledMobileMenuFooterWrapper>
                    {
                        playerContext?.wallet.connected ? (
                            <>
                                <StyledLink to="/profile" className={`${location.pathname == "/profile" ? "active" : ""}`}>Profile</StyledLink>
                                <StyledLink to="/profit" className={`${location.pathname == "/profit" ? "active" : ""}`}>Profit</StyledLink>
                                <h3 style={{ margin: 0 }} onClick={handleDisConnectWallet}>Disconnect</h3>
                            </>
                        )
                            : (
                                <h3 style={{ margin: 0 }} onClick={handleConnectWallet}>Connect Wallet</h3>
                            )
                    }

                </StyledMobileMenuFooterWrapper>
            </Menu>
        </StyledNav>
    );
}

export default MobileNav;
